export default __webpack_public_path__ + "media/jamieVid.49f9189a.mp4";